import { Time } from '@vidstack/react';
export function TimeGroup() {
  return <div className="vds-time-group" data-sentry-component="TimeGroup" data-sentry-source-file="time-group.tsx">
      <Time className="vds-time" type="current" data-sentry-element="Time" data-sentry-source-file="time-group.tsx" />
      <div className="vds-time-divider">/</div>
      <Time className="vds-time" type="duration" data-sentry-element="Time" data-sentry-source-file="time-group.tsx" />
    </div>;
}